import {
  Box,
  Container,
  Typography,
  Button,
  useTheme,
  CircularProgress,
  useMediaQuery,
} from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useState, useEffect } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../../config/config";
import {
  checkInitialStateForDisableAcceptButton,
  isAnyOptInInNullState,
} from "../../../../../../../utils/optInsHelpers";
import IconTitle from "../../../../../../shared/components/IconTitle";
import OptinsManager from "../../../../../../shared/components/OptinsManager";
import ResponsiveDialog from "../../../../../../shared/components/ResponsiveDialog";
import ResponsiveLayout from "../../../../../../shared/components/ResponsiveLayout";
import Text from "../../../../../../shared/components/Text";
import { ONBOARDING_FULFILLED_BY_TYPES } from "../../../../../../shared/config";

export default function GDPROptinsDialog({
  participant,
  form,
  acceptTerms,
  showOptinsDialog,
  optInsArray,
  areOptInsSynced,
  setShowOptinsDialog,
}) {
  const { palette, customBorderRadius, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { handleSubmit, getValues, errors, register, control, setValue } = form;

  const [disableAcceptButton, setDisableAcceptButton] = useState(true);

  const isOnboardingFulfilledByMerchantPOS =
    participant.onboardingFulfilledBy ===
    ONBOARDING_FULFILLED_BY_TYPES.MERCHANT_POS;

  useEffect(() => {
    setDisableAcceptButton(
      checkInitialStateForDisableAcceptButton(optInsArray)
    );
  }, []);

  const handleOptInsChange = (name, value) => {
    setValue(name, value);
    setDisableAcceptButton(isAnyOptInInNullState(getValues()));
  };

  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "GDPR optins dialog",
      }}
      className={showOptinsDialog ? "fade-in" : "fade-out"}
      displayCondition={true}
      fullScreenCondition={true}
      open={true}
      onClose={() => {
        setShowOptinsDialog(false);
      }}
    >
      <Container
        style={{
          padding: "0 1rem",
          height: "100%",
        }}
      >
        <ResponsiveLayout>
          <Box>
            <Box style={{ height: isScreenXs ? "10vh" : "7vh" }} />
            <IconTitle
              className="appear-anim"
              icon={
                <ThemedAsset
                  id={assetIds.ICON_LOAN_ADJUST}
                  width={ICON_TITLE_HEIGHT}
                  height={ICON_TITLE_HEIGHT}
                  style={{ color: palette.secondary.main }}
                />
              }
              title={<Text tId={"DATA_TREATMENT"} />}
              subtitle={<Text tId="AGREE_CONDITIONS" />}
            />
          </Box>
          {areOptInsSynced ? (
            <Box>
              <Box className="appear-anim">
                <Box mb={1} width={"100%"}>
                  <Typography
                    variant="caption"
                    align="center"
                    color="textPrimary"
                    style={{
                      lineHeight: 1.5,
                      fontSize: 11,
                      wordWrap: "anywhere",
                    }}
                  >
                    <Text tId="NEED_TO_CHOOSE_TO_CONTINUE" />
                  </Typography>
                </Box>
                {isOnboardingFulfilledByMerchantPOS && (
                  <Box id="gdpr-box-welcome-subtitle" mb={1} display={"flex"}>
                    <Typography
                      align={"center"}
                      variant={"caption"}
                      color={"textPrimary"}
                    >
                      <Text tId={"PROVIDE_CONDITIONS_TO_CLIENT"} />
                    </Typography>
                  </Box>
                )}
                <OptinsManager
                  optInsState={optInsArray}
                  handleChange={handleOptInsChange}
                  errors={errors}
                  register={register}
                  control={control}
                />
                <Box
                  mt={4}
                  height={50}
                  style={{
                    width: "100%",
                  }}
                >
                  <Box
                    style={{ width: "100%" }}
                    borderRadius={customBorderRadius.button}
                    id="main-button-container"
                  >
                    <Button
                      style={{
                        width: "100%",
                        height: 48,
                      }}
                      className="progression"
                      variant="contained"
                      color="primary"
                      disabled={disableAcceptButton}
                      onClick={handleSubmit(acceptTerms)}
                    >
                      <Text tId="APPLY_FOR_LOAN" />
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  className={"transition-all"}
                  size={90}
                  thickness={1.5}
                  color="secondary"
                />
              </Box>
              <Box style={{ height: 100 }} />
            </>
          )}
        </ResponsiveLayout>
      </Container>
    </ResponsiveDialog>
  );
}
